module.exports = __webpack_public_path__ + "static/media/view test info student.64900ff3.svg";